import { API_URL, authFetch } from "../../api_calls.js";

async function parseJsonResponse(response, fallbackMessage) {
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }

  if (!response.ok) {
    const error = new Error(body?.detail || fallbackMessage);
    error.status = response.status;
    error.body = body;
    throw error;
  }

  return body;
}

async function jsonRequest(path, { method = "GET", body } = {}) {
  const response = await authFetch(`${API_URL}${path}`, {
    method,
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  return parseJsonResponse(response, `Professor onboarding request failed: ${method} ${path}`);
}

export async function getProfessorOnboardingState() {
  return jsonRequest("/professor/onboarding");
}

export async function confirmProfessorOnboardingProfile(payload = {}) {
  return jsonRequest("/professor/onboarding/profile", {
    method: "PUT",
    body: payload,
  });
}

export async function confirmProfessorOnboardingCenter(payload) {
  return jsonRequest("/professor/onboarding/center", {
    method: "PUT",
    body: payload,
  });
}

export async function createOrSelectProfessorOnboardingClassroom(payload) {
  return jsonRequest("/professor/onboarding/classroom", {
    method: "POST",
    body: payload,
  });
}

export async function updateProfessorOnboardingStudentsStep(payload) {
  return jsonRequest("/professor/onboarding/students-step", {
    method: "PUT",
    body: payload,
  });
}

export async function completeProfessorOnboarding() {
  return jsonRequest("/professor/onboarding/complete", {
    method: "POST",
  });
}

export async function updateProfessorOnboardingTutorial(payload) {
  return jsonRequest("/professor/onboarding/tutorial", {
    method: "PUT",
    body: payload,
  });
}
